enum InputVariant {
  FILLED = "primary",
  FILLED_NEW_PRIMARY = "newPrimary",
  SECONDARY_FILLED = "secondary",
}

export default InputVariant;
